import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, Route, Switch, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

import { Helmet } from "react-helmet";
import Topbar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import { URLS } from "../urls";

import Datepicker from "react-datetime";
import moment from "moment";
import "../../../src/assets/css/ga-styles.css";
import { toast } from "react-toastify";

function Termination() {
  const date = new Date();
  const initialTerminationData = {
    employeeId: "",
    departmentId: "",
    reason: "",
    noticeDate: moment(date).format("DD/MM/YYYY"),
    terminationDate: moment(date).format("DD/MM/YYYY"),
    terminationType: ["misconduct"],
  };

  const [employees, setEmployees] = useState([]);
  const [terminationData, setTerminationData] = useState(
    initialTerminationData
  );

  const [terminationIdToDelete, setTerminationIdToDelete] = useState("");

  const [terminationDataToEdit, setTerminationDataToEdit] = useState({
    employeeName: "",
    employeeId: "",
    departmentId: "",
    terminationDate: "",
    reason: "",
    noticeDate: "",
    terminationType: ["misconduct"],
  });

  const [terminations, setTerminations] = useState([]);

  useEffect(() => {
    getEmployees();
    getTerminations();
    return () => {};
  }, []);

  const setTerminationDataForEdit = (termination) => {
    console.log(termination, employees);
    const employee = employees.find(
      (employee) => employee.userId === termination.employeeId
    );

    setTerminationDataToEdit({
      ...terminationDataToEdit,
      employeeName:
        employee?.personalInfo.name.first +
        " " +
        employee?.personalInfo.name.last,
      employeeId: termination.employeeId,
      departmentId: termination.departmentId,
      terminationDate: termination.terminationDate,
      reason: termination.reason,
      noticeDate: termination.noticeDate,
      terminationType: termination.terminationType,
    });
  };

  const setEmployeeId = (userId) => {
    const employee = employees.find((employee) => employee.userId === userId);
    setTerminationData({
      ...terminationData,
      employeeId: userId,
      departmentId: employee.jobInfo?.department?._id,
    });
  };

  const getTerminations = () => {
    const token = "dummy token";
    fetch(`${URLS.backendTermination}/get-terminations`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        const date = new Date();
        if (result.terminations) {
          setTerminations(result.terminations);
        }
      })
      .catch((err) => console.log(err));
  };

  const getEmployees = () => {
    const token = "dummy token";
    fetch(`${URLS.backendEmployees}/get`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.employees) {
          setEmployees(result.employees);
        }
      })
      .catch((err) => console.log(err));
  };

  const saveTermination = (e) => {
    e.preventDefault();

    const token = "dummy token";
    fetch(`${URLS.backendTermination}/save`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({ terminationData }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          // console.log(result);
          setTerminations([...terminations, result.termination]);
          setTerminationData({ ...initialTerminationData });
          window.$("#add_termination").modal("toggle");
          toast("Employee terminated", {
            type: "success",
          });
        } else {
          if (result.exists) {
            toast("Employee has already been terminated", {
              type: "error",
            });
            return;
          }
          throw Error();
        }
      })
      .catch((err) => {
        console.log(err);
        toast("Unable to submit", {
          type: "error",
        });
      });
  };

  const handleTerminationEditSubmit = (e) => {
    e.preventDefault();

    const token = "dummy token";
    fetch(`${URLS.backendTermination}/edit`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({ terminationDataToEdit }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          const foundIndex = terminations.findIndex(
            (termination) =>
              termination.employeeId === result.termination.employeeId
          );
          terminations[foundIndex] = result.termination;
          setTerminations([...terminations]);

          window.$("#edit_termination").modal("toggle");
          toast("Termination edited", {
            type: "success",
          });
        } else {
          throw Error();
        }
      })
      .catch((err) => {
        console.log(err);
        toast("Unable to submit", {
          type: "error",
        });
      });
  };

  const deleteTermination = () => {
    window.$("#delete_termination").modal("toggle");
    const token = "dummy token";
    fetch(`${URLS.backendTermination}/delete`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({ terminationId: terminationIdToDelete }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          const removedDeleted = terminations.filter(
            (termination) => termination._id !== terminationIdToDelete
          );
          setTerminations([...removedDeleted]);

          toast("Termination deleted", {
            type: "success",
          });
        } else {
          throw Error();
        }
      })
      .catch((err) => {
        console.log(err);
        toast("Unable to delete termination", {
          type: "error",
        });
      });
  };

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>Invex ERP</title>
      </Helmet>
      <div className="main-wrapper">
        <Topbar />
        <Sidebar />
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper">
          {/*<!-- Page Content -->*/}
          <div className="content container-fluid">
            {/*<!-- Page Title -->*/}
            <div className="row">
              <div className="col">
                <Breadcrumb>
                  <BreadcrumbItem>
                    <Link to={`${URLS.dashboard}`}>Dashboard</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>Termination</BreadcrumbItem>
                </Breadcrumb>
                {/* <h4 className="page-title">Employee</h4> */}
              </div>
              <div className="col-auto text-right float-right ml-auto m-b-30">
                <a
                  href="#"
                  className="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_termination"
                >
                  <i className="fa fa-plus"></i>Add Termination
                </a>
              </div>
            </div>
            {/*<!-- /Page Title -->*/}

            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  {
                    <table className="table table-striped custom-table mb-0 datatable">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Terminated Employee </th>
                          <th>Department</th>
                          <th>Termination Type </th>
                          <th>Termination Date </th>
                          <th>Reason</th>
                          <th>Notice Date </th>
                          <th className="text-right">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {terminations.map((termination, index) => {
                          const { employee, department } = termination;

                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <h2 className="table-avatar blue-link">
                                  <Link
                                    to={`profile/${employee.userId}`}
                                    className="avatar"
                                  >
                                    <img
                                      alt=""
                                      src="assets/img/profiles/avatar-02.jpg"
                                    />
                                  </Link>
                                  <Link to={`profile/${employee.userId}`}>
                                    {employee.personalInfo.name.first +
                                      " " +
                                      employee.personalInfo.name.last}
                                  </Link>
                                </h2>
                              </td>
                              <td>{department?.name}</td>
                              <td>
                                {termination.terminationType.map(
                                  (type, index) => {
                                    return <span key={index}>{type}</span>;
                                  }
                                )}
                              </td>
                              <td>{termination.terminationDate}</td>
                              <td>{termination.reason}</td>
                              <td>{termination.noticeDate}</td>
                              <td className="text-right">
                                <div className="dropdown dropdown-action">
                                  <a
                                    href="#"
                                    className="action-icon dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="material-icons">more_vert</i>
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      data-toggle="modal"
                                      data-target="#edit_termination"
                                      onClick={(e) =>
                                        setTerminationDataForEdit(termination)
                                      }
                                    >
                                      <i className="fa fa-pencil m-r-5"></i>{" "}
                                      Edit
                                    </a>
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      data-toggle="modal"
                                      data-target="#delete_termination"
                                      onClick={(e) => {
                                        setTerminationIdToDelete(
                                          termination._id
                                        );
                                      }}
                                    >
                                      <i className="fa fa-trash-o m-r-5"></i>{" "}
                                      Delete
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  }
                </div>
              </div>
            </div>
          </div>
          {/*<!-- /Page Content -->*/}

          {/*<!-- Add Termination Modal -->*/}
          <div
            id="add_termination"
            className="modal custom-modal fade"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Termination</h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form onSubmit={(e) => saveTermination(e)}>
                    <div className="form-group">
                      <label>
                        Terminated Employee{" "}
                        <span className="text-danger">*</span>
                      </label>
                      {employees && (
                        <select
                          className="form-control"
                          name="employeeId"
                          required
                          onChange={async (e) => {
                            setEmployeeId(e.target.value);
                          }}
                          value={terminationData.employeeId}
                        >
                          <option disabled selected value={""}>
                            Select Employee
                          </option>
                          {employees.map((employee, index) => {
                            return (
                              <option key={index} value={employee.userId}>
                                {employee.personalInfo.name.first +
                                  " " +
                                  employee.personalInfo.name.last}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Termination Type <span className="text-danger">*</span>
                      </label>
                      <div className="">
                        {terminationData.terminationType.map((type, index) => {
                          return (
                            <div key={index} className="d-flex">
                              <select
                                value={type}
                                className="form-control"
                                onChange={(e) => {
                                  const terminationType =
                                    terminationData.terminationType;
                                  terminationType[index] = e.target.value;
                                  setTerminationData({
                                    ...terminationData,
                                    terminationType,
                                  });
                                }}
                              >
                                <option value="">
                                  Select Termination type
                                </option>
                                <option value="misconduct">Misconduct</option>
                                <option value="abuse">Abuse</option>
                                <option value="others">Others</option>
                              </select>
                              <span
                                className="m-3"
                                title="remove"
                                onClick={() => {
                                  if (
                                    terminationData.terminationType.length > 1
                                  ) {
                                    const terminationType =
                                      terminationData.terminationType;
                                    terminationType.splice(index, 1);
                                    setTerminationData({
                                      ...terminationData,
                                      terminationType,
                                    });
                                  }
                                }}
                              >
                                <i className="fa fa-times"></i>
                              </span>
                            </div>
                          );
                        })}

                        <a
                          className="btn btn-primary"
                          href="javascript:void(0);"
                          onClick={() =>
                            setTerminationData({
                              ...terminationData,
                              terminationType: [
                                ...terminationData.terminationType,
                                "",
                              ],
                            })
                          }
                        >
                          <i className="fa fa-plus"></i> Add
                        </a>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>
                        Termination Date <span className="text-danger">*</span>
                      </label>
                      <div className="cal-icon">
                        <div classname="datePicker position-absolute">
                          <Datepicker
                            id={"terminationDate"}
                            value={terminationData.terminationDate}
                            onChange={(e) => {
                              setTerminationData({
                                ...terminationData,
                                terminationDate: moment(e._d).format(
                                  "DD/MM/YYYY"
                                ),
                              });
                            }}
                            closeOnSelect={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>
                        Reason <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows="4"
                        value={terminationData.reason}
                        onChange={(e) => {
                          setTerminationData({
                            ...terminationData,
                            reason: e.target.value,
                          });
                        }}
                      ></textarea>
                    </div>
                    <div className="form-group">
                      <label>
                        Notice Date <span className="text-danger">*</span>
                      </label>
                      <div className="cal-icon">
                        <Datepicker
                          id={"noticeDate"}
                          value={terminationData.noticeDate}
                          onChange={(e) => {
                            setTerminationData({
                              ...terminationData,
                              noticeDate: moment(e._d).format("DD/MM/YYYY"),
                            });
                          }}
                          closeOnSelect={true}
                        />
                      </div>
                    </div>
                    <div className="submit-section">
                      <button className="btn btn-primary submit-btn">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/*<!-- /Add Termination Modal -->*/}

          {/*<!-- Edit Termination Modal -->*/}
          {
            <div
              id="edit_termination"
              className="modal custom-modal fade"
              role="dialog"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Termination</h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={(e) => handleTerminationEditSubmit(e)}>
                      <div className="form-group">
                        <label>
                          Terminated Employee{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={terminationDataToEdit.employeeName}
                        />
                      </div>
                      <div className="form-group">
                        <label>
                          Termination Type{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="">
                          {terminationDataToEdit.terminationType.map(
                            (type, index) => {
                              return (
                                <div key={index} className="d-flex">
                                  <select
                                    value={type}
                                    className="form-control"
                                    required
                                    onChange={(e) => {
                                      const terminationType =
                                        terminationDataToEdit.terminationType;
                                      terminationType[index] = e.target.value;
                                      setTerminationDataToEdit({
                                        ...terminationDataToEdit,
                                        terminationType,
                                      });
                                    }}
                                  >
                                    <option value="">
                                      Select Termination type
                                    </option>
                                    <option value="misconduct">
                                      Misconduct
                                    </option>
                                    <option value="abuse">Abuse</option>
                                    <option value="others">Others</option>
                                  </select>
                                  <span
                                    className="m-3"
                                    title="remove"
                                    onClick={() => {
                                      if (
                                        terminationDataToEdit.terminationType
                                          .length > 1
                                      ) {
                                        const terminationType =
                                          terminationDataToEdit.terminationType;
                                        terminationType.splice(index, 1);
                                        setTerminationDataToEdit({
                                          ...terminationDataToEdit,
                                          terminationType,
                                        });
                                      }
                                    }}
                                  >
                                    <i className="fa fa-times"></i>
                                  </span>
                                </div>
                              );
                            }
                          )}
                          <a
                            className="btn btn-primary"
                            href="javascript:void(0);"
                            onClick={() => {
                              setTerminationDataToEdit({
                                ...terminationDataToEdit,
                                terminationType: [
                                  ...terminationDataToEdit.terminationType,
                                  "",
                                ],
                              });
                            }}
                          >
                            <i className="fa fa-plus"></i> Add
                          </a>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>
                          Termination Date{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="cal-icon">
                          <div classname="datePicker position-absolute">
                            <Datepicker
                              id={"terminationDate"}
                              value={terminationDataToEdit.terminationDate}
                              onChange={(e) => {
                                setTerminationDataToEdit({
                                  ...terminationDataToEdit,
                                  terminationDate: moment(e._d).format(
                                    "DD/MM/YYYY"
                                  ),
                                });
                              }}
                              closeOnSelect={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>
                          Reason <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          rows="4"
                          value={terminationDataToEdit.reason}
                          onChange={(e) => {
                            setTerminationDataToEdit({
                              ...terminationDataToEdit,
                              reason: e.target.value,
                            });
                          }}
                        ></textarea>
                      </div>
                      <div className="form-group">
                        <label>
                          Notice Date <span className="text-danger">*</span>
                        </label>
                        <div className="cal-icon">
                          <Datepicker
                            id={"noticeDate"}
                            value={terminationDataToEdit.noticeDate}
                            onChange={(e) => {
                              setTerminationDataToEdit({
                                ...terminationDataToEdit,
                                noticeDate: moment(e._d).format("DD/MM/YYYY"),
                              });
                            }}
                            closeOnSelect={true}
                          />
                        </div>
                      </div>
                      <div className="submit-section">
                        <button className="btn btn-primary submit-btn">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          }
          {/*<!-- /Edit Termination Modal -->*/}

          {/*<!-- Delete Termination Modal -->*/}
          <div
            className="modal custom-modal fade"
            id="delete_termination"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="form-header">
                    <h3>Delete Termination</h3>
                    <p>Are you sure want to delete?</p>
                  </div>
                  <div className="modal-btn delete-action">
                    <div className="row">
                      <div className="col-6">
                        <a
                          href="javascript:void(0);"
                          className="btn btn-primary continue-btn"
                          onClick={() => deleteTermination()}
                        >
                          Delete
                        </a>
                      </div>
                      <div className="col-6">
                        <a
                          href="javascript:void(0);"
                          data-dismiss="modal"
                          className="btn btn-primary cancel-btn"
                        >
                          Cancel
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*<!-- /Delete Termination Modal -->*/}
        </div>
        {/*<!-- /Page Wrapper -->*/}
      </div>
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <div className="sidebar-overlay" data-reff=""></div>
    </body>
  );
}

const mapStateToProps = (state) => {
  return {
    User: state.api.User,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Termination));
